import { Injectable }         from '@angular/core';
import { TranslateService }   from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {


  constructor(
    private _translateService   : TranslateService,
  ) { 
  }

  translate(word)
  {
    return this._translateService.instant(word);
  }

  public static compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? 1 : -1) * (isAsc ? -1 : 1);
  }
  
  public static date_to_timestring(a,separator = "-")
  {
    var year    = a.getFullYear();
    var month   = ("0" + (a.getMonth() + 1)).slice(-2)
    var day     = ("0" + a.getDate()).slice(-2)
    var hour    = ("0" + a.getHours()).slice(-2);
    var minutes = ("0" + a.getMinutes()).slice(-2);
    var sec     = ("0" + a.getSeconds()).slice(-2);
    var time    = year + separator + month + separator + day + " "+ hour + ':' + minutes + ':' + sec ;
    return time;
  }

  public static timestamp_to_datetime(timestamp,separator = "-") {
    if (timestamp === "" || timestamp === " " || timestamp === undefined || timestamp === null) return "-";
    var a       = new Date(timestamp);
    var year    = a.getFullYear();
    var month   = ("0" + (a.getMonth() + 1)).slice(-2)
    var day     = ("0" + a.getDate()).slice(-2)
    var hour    = ("0" + a.getHours()).slice(-2);
    var minutes = ("0" + a.getMinutes()).slice(-2);
    var sec     = ("0" + a.getSeconds()).slice(-2);
    var time    = year + separator + month + separator + day + " "+ hour + ':' + minutes + ':' + sec ;
    return time;
  }

  public static timestamp_to_date(timestamp,separator = "-") {
    if (timestamp === "" || timestamp === " " || timestamp === undefined || timestamp === null) return "-";
    var a       = new Date(timestamp);
    var year    = a.getFullYear();
    var month   = ("0" + (a.getMonth() + 1)).slice(-2)
    var day     = ("0" + a.getDate()).slice(-2)
    var time    = year + separator + month + separator + day;
    return time;
  }

  public static timestamp_to_time(timestamp)
  {
      if (timestamp === "" || timestamp === undefined || timestamp === null) return "-";
      var a       = new Date(timestamp);
      var hour    = ("0" + a.getHours()).slice(-2);
      var minutes = ("0" + a.getMinutes()).slice(-2);
      var sec     = ("0" + a.getSeconds()).slice(-2);
      var time    = hour + ':' + minutes + ':' + sec ;
      return time;
  }

  public static timestamp_to_dateformat(timestamp, format)
  {
    var a = new Date(timestamp);
    var dateString = moment(a).format(format);
    return dateString;
  }

  public static numberWithCommas(x) {
    var parts = x.toString().split(",");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  }
  
  public humanFileSize(bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }
  
  public static getWeekNumber(d = null) {
    if (d === null)
    {
      d = new Date();
    }
    
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const pastDaysOfYear = (today.valueOf() - firstDayOfYear.valueOf()) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
  }
  
  public static getCurrentMonth()
  {
    var d = new Date();
    return d.getMonth() + 1;
  }

 static array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };
  
  public static keyValueToString(obj , separator = ", ")
  {
    return Object.keys(obj).map(function (key) { 
      return "" + key + "=" + obj[key]; // line break for wrapping only
    }).join(separator)
  }

  public days_between_dates(d1 , d2)
  {
    var difference_time = d2.getTime() - d1.getTime(); 
    return Math.floor(difference_time / (1000 * 3600 * 24)) + 1; 
  }
  
  
  public static convertDate(date_to_convert)
  {
    if (date_to_convert === null)
    {
      return null;
    }
    date_to_convert.set("seconds",0);
    return (Math.floor(new Date(date_to_convert).getTime() / 1000)).toString();
  }
  
  public static prettyBytesSeconds(number, fixed = 2)
  {
      var num_digits = parseInt(number).toString().length;
      var legend = "bit/s";
      // console.log("NUMBER: "+number+" DIGITS: "+num_digits);
      if (number === 0) return number;

      var i = -1;
      var byteUnits = [' kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
      do {
          number = number / 1000;
          i++;
      } while (number > 1000);

      return Math.max(number, 0.1).toFixed(fixed) + byteUnits[i];
  }

  public static prettyBytes(number,options = { "signed" : false , "no_unit" : false , "only_unit" : false })
  {
      var UNITS = ['B','kB','MB','GB','TB','PB','EB','ZB','YB'];

      if ( typeof number === 'string' )
      {
        number = Number(number);
      }

      if (!Number.isFinite(number)) {
          return "Number Error";
      }

      options = Object.assign({}, options);

      if (options.signed && number === 0) {
          return ' 0 B';
      }

      const isNegative = number < 0;
      const prefix = isNegative ? '-' : (options.signed ? '+' : '');

      if (isNegative) {
          number = -number;
      }

      if (number < 1) {
          const numberString = number+"";
          return prefix + numberString + ' B';
      }

      const exponent = Math.min(Math.floor(Math.log10(number) / 3), UNITS.length - 1);
      number = Number((number / Math.pow(1000, exponent)).toPrecision(3));
      const numberString = number+"";

      const unit = UNITS[exponent];

      if (options.no_unit !== undefined && options.no_unit) return numberString;
      if (options.only_unit !== undefined && options.only_unit) return unit;
      return prefix + numberString + ' ' + unit;

  }

  public static getIPPattern()
  {
    return "^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$";
  }

  public static generateFakeId()
  {
    return Math.floor(Math.random() * 10000000) + 1000000
  }

  public static empty(val)
  {
    return val === "" || val === null || val === undefined;
  }

  static adjust_timestamp(utc_timestamp) {
    return Math.floor(utc_timestamp).toString().length === 10 ? Math.floor(utc_timestamp) * 1000 : Math.floor(utc_timestamp);
  }

  static prettySec(sec)
  {
      var d = Number(sec);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);
  
      return [h,m,s].join(":");
  }

  // static prettyNumber(number)
  // {
  //   return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
  // }

  static getBoolean(value) {
      switch (value) {
          case true:
          case "true":
          case 1:
          case "1":
          case "on":
          case "yes":
              return true;
          default:
              return false;
      }
  }

}
